module.exports = __webpack_public_path__ + "img/SG.d3adca7e.png";